import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
};

export default function RHFTextField({ name, ...other }) {
  const { control } = useFormContext();



  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          style={{ marginBottom: 12 }}
          size="small"
          {...field}
          fullWidth
          error={!!error}
          helperText={error?.message}
          onFocus={(e) =>
            e.target.addEventListener(
              'wheel',
              (e) => {
                e.preventDefault();
              },
              { passive: false }
            )
          }
          {...other}
        />
      )}
    />
  );
}
